export class ArchiviaPraticaRequest {
  idPratica: string;
  dataArchiviazione: number;
}
